var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shane_tm_intro shane_error_page"},[_c('div',{staticClass:"hero",style:({ backgroundImage: 'url(' + _vm.imgSrc + ')' })},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v("404!")]),_c('p',[_vm._v("The page you are looking for could not be found.")]),_c('div',{staticClass:"white-fill-bg btn-outline"},[_vm._v(" BACK TO HOME ")])])
}]

export { render, staticRenderFns }